import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsClockIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 24 28" {...props}>
    <g>
      <path d="M14 8.5v7c0 0.281-0.219 0.5-0.5 0.5h-5c-0.281 0-0.5-0.219-0.5-0.5v-1c0-0.281 0.219-0.5 0.5-0.5h3.5v-5.5c0-0.281 0.219-0.5 0.5-0.5h1c0.281 0 0.5 0.219 0.5 0.5zM20.5 14c0-4.688-3.813-8.5-8.5-8.5s-8.5 3.813-8.5 8.5 3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5zM24 14c0 6.625-5.375 12-12 12s-12-5.375-12-12 5.375-12 12-12 12 5.375 12 12z" />
    </g>
  </StyledIcon>
)

CsClockIcon.displayName = 'CsClockIcon'
